import SessionActionType from './session.types';
import type { RoleId } from '../../data/tisms-api';

export type Lang = 'en' | 'ta';

export const setRole = (roleId: string) => ({
  type: SessionActionType.SESSION_SET_ROLE,
  payload: roleId,
});
export const setLang = (lang: Lang) => ({
  type: SessionActionType.SESSION_SET_LANG,
  payload: lang,
});
export const sessionReset = () => ({ type: SessionActionType.SESSION_RESET });

export type SessionAction =
  | ReturnType<typeof setRole>
  | ReturnType<typeof setLang>
  | ReturnType<typeof sessionReset>;
